import { AgreementDto } from "@services/Api/api.dto";

export const getRequiredAgreementsId = (agreements: AgreementDto[]) => {
  const requiredAgreements = agreements.filter((agreement) => agreement.required === true);
  return requiredAgreements.map((agreement) => agreement.id as string) || [];
};
